/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {GetSitePrefrences} from '../../custom-api/preferences/hooks/get-site-preferenes'

/**
 * This is the global state for the site custom preferences,  we use this throughout the site.
 * @type {React.Context<unknown>}
 */
export const SitePreferenceContext = React.createContext()
export const SitePreferenceProvider = ({children}) => {
    const {getcustomPreferencevalue} = GetSitePrefrences()
    return (
        <SitePreferenceContext.Provider value={{getcustomPreferencevalue}}>
            {children}
        </SitePreferenceContext.Provider>
    )
}

SitePreferenceProvider.propTypes = {
    children: PropTypes.node.isRequired
}

export * from '@salesforce/retail-react-app/app/contexts'
